import React from 'react';
import { useTranslation } from 'react-i18next';
import HowToUse from 'components/HowToUse/HowToUse';

export default function ItemTrackerHowToUse() {
  const { t } = useTranslation();

  return (
    <HowToUse
      title={t('itemTracker.howToUse.title')}
      whatIsIt={t('itemTracker.howToUse.whatIsIt')}
      description={t('itemTracker.howToUse.description')}
      featuresTitle={t('itemTracker.howToUse.features')}
      features={[
        t('itemTracker.howToUse.feature1'),
        t('itemTracker.howToUse.feature2'),
        t('itemTracker.howToUse.feature3'),
        t('itemTracker.howToUse.feature4'),
      ]}
      howToUseTitle={t('itemTracker.howToUse.howToUse')}
      steps={[
        t('itemTracker.howToUse.step1'),
        t('itemTracker.howToUse.step2'),
        t('itemTracker.howToUse.step3'),
        t('itemTracker.howToUse.step4'),
      ]}
      tipsTitle={t('itemTracker.howToUse.tips')}
      tips={[
        t('itemTracker.howToUse.tip1'),
        t('itemTracker.howToUse.tip2'),
        t('itemTracker.howToUse.tip3'),
      ]}
    />
  );
}
